import React, {useEffect, useState} from 'react';
import {getHeaderNotification,  getFaqsData} from './../utils/endpoints'
import HeaderNotification from './components/headerNotification';
import Loading from './components/loading';
import Header from './components/header';
import Footer from './components/footer';
import { Container} from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import file01 from '../assets/pdf/annual-return/2015.09.29_Form-MGT-7_Tatpadam-Upavan.pdf'
import file02 from '../assets/pdf/annual-return/2016.09.26_Form-MGT-7_Tatpadam-Upavan.pdf'
import file03 from '../assets/pdf/annual-return/2017.09.25_Form_MGT-7_Tatpadam-Upavan.pdf'
import file04 from '../assets/pdf/annual-return/2018.09.15_Form-MGT-7_Tatpadam-Upavan.pdf'
import file05 from '../assets/pdf/annual-return/2019.09.28_Form-MGT7_Tatpadam-Upavan.pdf'
import file06 from '../assets/pdf/annual-return/2020.11.23_Form_MGT-7_Tatpadam-Upavan.pdf'
import file07 from '../assets/pdf/annual-return/2021.11.22_Form MGT-7_Tatpadam-Upavan.pdf'
import file08 from '../assets/pdf/annual-return/2022.09.26_Form MGT-7_Tatpadam-Upavan.pdf'
import file09 from '../assets/pdf/annual-return/2023.09.27_Form MGT-7_Tatpadam-Upavan.pdf'
import file10 from '../assets/pdf/annual-return/2024.09.30_Form MGT-7_Tatpadam-Upavan.pdf'


const AnnualReturn = () => {
  const [headerNotificationData, setheaderNotificationData] = useState(null);
  const [faqs, setFaqs] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const faqs = await getFaqsData();
        const headerNotificationData = await getHeaderNotification();
        setheaderNotificationData(headerNotificationData);
        setFaqs(faqs);
        
        setIsLoading(false);
      } catch (error) {
        setError(error);
        setIsLoading(false);
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const faQSlice = faqs;

  if (isLoading) {
    return <div><Loading /></div>;
  }

  if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      <Helmet>
      <title>Annual Return | Investors | Statue of Belief</title>
      </Helmet>
      <HeaderNotification compData={headerNotificationData}/>
      <Header />
      <section className='section-breadcrumb'>
      <Container>
      <ul>
            <li><a href="/">Home</a></li>
            <li>Annual Return</li>
        </ul>
        <h1>Annual Return</h1>
      </Container>
    </section>
    <section className='section-about'>
    <Container>
      <h2 class="mb-3">Annual Return</h2>
        <ul className='list-item'>
            <li><a href={file01} download>2015.09.29_Form-MGT-7_Tatpadam Upavan</a></li>
            <li><a href={file02} download>2016.09.26_Form-MGT-7_Tatpadam Upavan</a></li>
            <li><a href={file03} download>2017.09.25_Form_MGT-7_Tatpadam Upavan</a></li>
            <li><a href={file04} download>2018.09.15_Form-MGT-7_Tatpadam Upavan</a></li>
            <li><a href={file05} download>2019.09.28_Form-MGT7_Tatpadam Upavan</a></li>
            <li><a href={file06} download>2020.11.23_Form_MGT-7_Tatpadam Upavan</a></li>
            <li><a href={file07} download>2021.11.22_Form MGT-7_Tatpadam Upavan</a></li>
            <li><a href={file08} download>2022.09.26_Form MGT-7_Tatpadam Upavan</a></li>
            <li><a href={file09} download>2023.09.27_Form MGT-7_Tatpadam Upavan</a></li>
            <li><a href={file10} download>2024.09.30_Form MGT-7_Tatpadam Upavan</a></li>
        </ul>
    </Container>
    </section>
    <Footer />
    </div>
  );
};

export default AnnualReturn;